export default __webpack_public_path__ + "static/media/storexplore-chats.ce2cc2ba.png";